import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const FAILED_TRACKING_SCHEMA = Object.freeze({
  SCREEN_NAME: '',
  ERROR_MESSAGE: '',
});
const RECORD = generateSchema(FAILED_TRACKING_SCHEMA);
const KEYS: any = generateKeys(FAILED_TRACKING_SCHEMA);

export class FailedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.failed;
  }

  get properties() {
    return this.toJS();
  }
}
